var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_1891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.172 12.8809V14.6043H19.9018L19.5425 17.4058H17.172V24.3028H14.299V17.4058H12V14.6043H14.299V12.1623C14.299 7.99506 19.9018 9.14458 19.9018 9.14458V11.5884H18.4645C16.8842 11.5884 17.172 12.8809 17.172 12.8809Z",
    fill: "#9B9C9C"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.589286,
    y: 0.589286,
    width: 31.8214,
    height: 31.8214,
    rx: 15.9107,
    stroke: "#9B9C9C",
    strokeWidth: 1.17857
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_1891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.90185,
    height: 15.303,
    fill: "white",
    transform: "translate(12 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.b3667eb09f2fe2c5af2e7c315ea3e8e3.svg";
export { ForwardRef as ReactComponent };